import Route from '../Route'
import { CustomSwitch } from '../../components/CustomSwitch'
import QueueInvoices from 'pages/Financial/QueueInvoices/List'

export const QueueInvoicesRouter = (): JSX.Element => (
  <CustomSwitch>
    <Route path="/financial/queueInvoices" exact component={QueueInvoices} />
  </CustomSwitch>
)
